import { render, staticRenderFns } from "./RetrieveAccount.vue?vue&type=template&id=f28efac2&"
import script from "./RetrieveAccount.vue?vue&type=script&lang=js&"
export * from "./RetrieveAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports